import React, { useState } from 'react';
import Button from '../Button';

type ToastProps = {
  message: string;
  /** Name of the animate.css animation for appearing */
  animationIn?: string;
  /** Name of the animate.css animation for closing */
  animationOut?: string;
  onClose: () => void;
};

export default function Toast({
  message,
  onClose,
  animationIn = '',
  animationOut = '',
}: ToastProps) {
  const [animation, setAnimation] = useState(animationIn);

  function handleClose() {
    if (animationOut) {
      setAnimation(animationOut);

      // 1s is the default animation time for animate.css
      setTimeout(() => {
        onClose();
      }, 1000);
    } else {
      onClose();
    }
  }

  const animationClass = `animate__${animation}`;

  return (
    <div className={`toast animate__animated ${animationClass}`}>
      <p>{message}</p>
      <Button onClick={handleClose} type="bare">
        OK
      </Button>
    </div>
  );
}
